(function () {
  function initShopping() {
    var wishlist = document.getElementById('WishlistDialog');
    if (!wishlist) return;
    var storageKey = 'mlpine-wishlist-v1';
    var recentKey = 'mlpine-recent-v1';
    function validItem(item) {
      if (!item || typeof item.id !== 'string' || typeof item.title !== 'string') return false;
      try {
        var link = new URL(item.url, location.origin);
        var picture = new URL(item.image, location.origin);
        return link.origin === location.origin && /^(https?:)$/.test(link.protocol) && (picture.origin === location.origin || picture.hostname === 'cdn.shopify.com') && /^(https?:)$/.test(picture.protocol);
      } catch (_) { return false; }
    }
    function readItems(key) {
      try { var items = JSON.parse(localStorage.getItem(key) || '[]'); return Array.isArray(items) ? items.filter(validItem).slice(0, 40).map(function (item) { if (item.id === 'eager-ski-set') item.title = 'Eiger'; return item; }) : []; } catch (_) { return []; }
    }
    var items = readItems(storageKey);
    function fromButton(button) { return { id: button.dataset.itemId, title: button.dataset.title, url: button.dataset.url, image: button.dataset.image, price: button.dataset.price }; }
    function createCard(item, removable) {
      var card = document.createElement('article'); card.className = 'saved-card';
      var link = document.createElement('a'); link.href = item.url;
      var img = document.createElement('img'); img.src = item.image; img.alt = item.title; img.loading = 'lazy'; img.width = 400; img.height = 500;
      var title = document.createElement('h3'); title.textContent = item.title;
      
      link.append(img, title); card.append(link);
      link.addEventListener('click', function () { if (wishlist.open) wishlist.close(); });
      if (removable) {
        var remove = document.createElement('button'); remove.type = 'button'; remove.className = 'text-link'; remove.textContent = wishlist.dataset.removeLabel;
        remove.addEventListener('click', function () { update(items.filter(function (entry) { return entry.id !== item.id; })); });
        card.append(remove);
      }
      return card;
    }
    function render() {
      var list = wishlist.querySelector('[data-wishlist-list]'); list.replaceChildren();
      items.forEach(function (item) { list.append(createCard(item, true)); });
      wishlist.querySelector('[data-wishlist-empty]').hidden = items.length > 0;
      document.querySelectorAll('[data-wishlist-count]').forEach(function (count) { count.textContent = items.length; });
      document.querySelectorAll('[data-save-piece]').forEach(function (button) {
        var saved = items.some(function (item) { return item.id === button.dataset.itemId; });
        button.setAttribute('aria-pressed', String(saved)); var label = button.querySelector('[data-save-label]'); if (label) label.textContent = saved ? wishlist.dataset.removeLabel : wishlist.dataset.saveLabel; button.setAttribute('aria-label', saved ? wishlist.dataset.removeLabel : wishlist.dataset.saveLabel);
      });
    }
    function update(next) {
      try { localStorage.setItem(storageKey, JSON.stringify(next)); items = next; render(); wishlist.querySelector('[data-wishlist-status]').textContent = ''; }
      catch (_) { wishlist.querySelector('[data-wishlist-status]').textContent = wishlist.dataset.storageError; if (!wishlist.open) { wishlist.showModal(); document.body.classList.add('locked'); } }
    }
    document.querySelectorAll('[data-save-piece]').forEach(function (button) {
      button.addEventListener('click', function () {
        var item = fromButton(button); if (!validItem(item)) return;
        var exists = items.some(function (saved) { return saved.id === item.id; });
        update(exists ? items.filter(function (saved) { return saved.id !== item.id; }) : [item].concat(items).slice(0, 40));
      });
    });
    window.addEventListener('storage', function (event) { if (event.key === storageKey) { items = readItems(storageKey); render(); } });
    render();
    var current = document.querySelector('[data-current-piece]');
    if (current) {
      var button = current.querySelector('[data-save-piece]');
      var recent = readItems(recentKey).filter(function (item) { return item.id !== current.dataset.currentPiece; });
      var list = document.querySelector('[data-recent-list]');
      if (list && recent.length) { recent.slice(0, 4).forEach(function (item) { list.append(createCard(item, false)); }); list.closest('section').hidden = false; }
      if (button && validItem(fromButton(button))) { try { localStorage.setItem(recentKey, JSON.stringify([fromButton(button)].concat(recent).slice(0, 8))); } catch (_) {} }
    }
    var zoom = document.getElementById('ImageZoom');
    function openImage(trigger) {
      var source = trigger.dataset.zoomImage || trigger.currentSrc || trigger.src;
      var original = trigger.tagName === 'IMG' ? trigger : trigger.querySelector('img');
      var image = zoom.querySelector('img'); image.src = source; image.alt = original ? original.alt : '';
      zoom.showModal(); document.body.classList.add('locked');
    }
    document.querySelectorAll('[data-zoomable],[data-zoom-image]').forEach(function (trigger) {
      trigger.addEventListener('click', function () { openImage(trigger); });
      if (trigger.tagName !== 'BUTTON') trigger.addEventListener('keydown', function (event) { if (event.key === 'Enter' || event.key === ' ') { event.preventDefault(); openImage(trigger); } });
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initShopping); else initShopping();
})();
